import { Location } from '@raydiant/api-client-js';

export interface ActivateRouteState {
  activationCode?: string;
}

// The code a scan carried in, trimmed; null when absent or blank.
export const readScannedCode = (state: unknown): string | null => {
  if (!state || typeof state !== 'object') return null;
  const { activationCode } = state as ActivateRouteState;
  if (typeof activationCode !== 'string') return null;
  const code = activationCode.trim();
  return code || null;
};

// Where the dialog starts for a scan: Lite's first location, the only
// location, or null when the member has several and picks one first.
export const scanStartLocation = (
  locations: Location[],
  isLiteUser: boolean,
): Location | null => {
  if (locations.length === 0) return null;
  if (isLiteUser || locations.length === 1) return locations[0];
  return null;
};
